import { statusDivider } from './statusDivider.model';
import { statusDividerTemplate } from './statusDivider.template';

export class StatusDivider {
	constructor(props) {
		this.initData(props);
		this.initWrapper();
		this.initEvent();
	}

	initData(propData) {
		this.data = {
			...statusDivider,
			...propData,
		};

		if (!propData?.status) {
			this.data = {
				...this.data,
				status: 'You closed the chat',
				hideDividers: false,
			};
		}
	}

	initWrapper() {
		const wrapper = document.createElement('div');

		if (this.data.id) {
			wrapper.id = this.data.id;
		}
		wrapper.classList.add('engtCloseChatDivider');
		wrapper.classList.add('engt-status-divider-wrapper');
		wrapper.setAttribute('data-messagetype', 'divider');
		wrapper.innerHTML = statusDividerTemplate(this.data);
		wrapper.setAttribute('data-messagetype', 'divider');

		this.html = wrapper;
	}

	initEvent() {}

	render() {
		return this.html;
	}
}
